import { useEffect, useRef, useState } from "react";
import { loginWithGoogle } from "../lib/api";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

const GoogleSignIn = ({ onSuccess }) => {
  const buttonRef = useRef(null);
  const onSuccessRef = useRef(onSuccess);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    onSuccessRef.current = onSuccess;
  }, [onSuccess]);

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID || !buttonRef.current) return undefined;

    let cancelled = false;

    const handleCredential = async (response) => {
      setError("");
      setIsLoading(true);
      try {
        const result = await loginWithGoogle(response.credential);
        if (result.success && result.token) {
          localStorage.setItem("auth_token", result.token);
          onSuccessRef.current();
        } else {
          setError(result.error || "Sign-in failed");
        }
      } catch (signInError) {
        setError(
          signInError instanceof Error
            ? signInError.message
            : "Failed to connect to server"
        );
      } finally {
        setIsLoading(false);
      }
    };

    const renderGoogleButton = () => {
      if (cancelled || !window.google || !buttonRef.current) return;
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredential,
      });
      buttonRef.current.replaceChildren();
      window.google.accounts.id.renderButton(buttonRef.current, {
        theme: "outline",
        size: "large",
        text: "continue_with",
        shape: "rectangular",
        width: 280,
        logo_alignment: "left",
      });
    };

    if (window.google) {
      renderGoogleButton();
      return () => {
        cancelled = true;
      };
    }

    const existing = document.querySelector(
      'script[src="https://accounts.google.com/gsi/client"]'
    );
    const script = existing || document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.addEventListener("load", renderGoogleButton);
    if (!existing) document.head.appendChild(script);

    return () => {
      cancelled = true;
      script.removeEventListener("load", renderGoogleButton);
    };
  }, []);

  return (
    <div className="pin-gate">
      <div className="pin-card">
        <div className="pin-card__mark" aria-hidden="true">
          <span className="workbench__logo">
            <span />
            <span />
            <span />
          </span>
        </div>
        <h2>Bead Pattern Designer</h2>
        <p className="pin-card__copy">
          Sign in with Google. Each account has its own studio.
        </p>
        {GOOGLE_CLIENT_ID ? (
          <div className="pin-card__google" ref={buttonRef} />
        ) : (
          <div className="pin-card__error">
            Google sign-in is not configured.
          </div>
        )}
        {isLoading && <p className="pin-card__copy">Signing in...</p>}
        {error && <div className="pin-card__error">{error}</div>}
      </div>
    </div>
  );
};

export default GoogleSignIn;
